Ext.define('SA.model.DataSort', {
    statics: {
        asc(attributeId) {
            return this.create({attributeId, direction: 'asc'});
        },

        create(params) {
            return new SA.model.DataSort(params);
        },

        desc(attributeId) {
            return this.create({attributeId, direction: 'desc'});
        },

        fromTuple([direction, attributeId]) {
            return this.create({attributeId, direction});
        }
    },

    constructor({attributeId, direction}) {
        this.attributeId = attributeId;
        this.direction = direction;
    },

    getAttributeId() {
        return this.attributeId;
    },

    getDirection() {
        return this.direction;
    },

    hasAttributeId(attributeId) {
        return this.attributeId === attributeId;
    },

    reversed() {
        return SA.model.DataSort.create({
            attributeId: this.getAttributeId(),
            direction: this.getDirection() === 'asc' ? 'desc' : 'asc'
        });
    },

    toTuple() {
        return [this.getDirection(), this.getAttributeId()];
    }
});